module.exports = __webpack_public_path__ + "static/media/logo.b5f9e9d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/header/logo.png
// module id = 404
// module chunks = 1 3 9